<template>
    <v-col class="my-0 py-0 px-0 px-md-10 pb-15">
        <!-- Alerta de información -->
        <v-col class="text-start mt-5 mb-3 px-0">
            <v-alert text dense color="#8061c2" border="left" class="pl-5">
                <h1 class="title mt-1">Estadísticas</h1>
                <p class="desc mt-0 mb-1">Gráficas y estadísticas de los agentes.</p>
            </v-alert>
        </v-col>

        <!-- Totales y Gráfica -->
        <v-col cols="12" class="px-0 py-0">
            <v-row no-gutters>
                <v-col class="col-md-6 col-12 px-0 pr-md-2">
                    <v-card cols="12" class="rounded-lg px-5 pt-4 pb-4" elevation="2">
                        <div class="d-flex">
                            <h3 class="text-left title-dashboard">Totales de ({{ selectedYear == 'Todos' ? 'Todos los años' : selectedYear }})</h3>
                            <v-progress-circular
                            v-if="loadingStatistics"
                            indeterminate
                            color="#8061c2"
                            width="2"
                            size="20"
                            class="mt-2 ml-2"
                            ></v-progress-circular>
                        </div>
                        <p class="text-left desc-dashboard mb-5">Conteo de mensajes totales, positivos, erroneos y sesiones.</p>
                        <v-row no-gutters>
                            <div class="col-12 px-md-4 pl-md-0 pt-0 mt-2 mb-2">
                                <v-row no-gutters>
                                    <div class="col-6 col-md-6 pr-1 pr-md-2 mb-2">
                                        <div class="rounded-lg d-card-views6 text-left px-3 py-6">
                                            <div class="d-flex align-center">
                                                <v-icon size="25px" color="#61d972" class="mr-2 iconos">mdi-robot</v-icon>
                                                <p class="mb-0 text-card" >{{ formatNumber(totalActiveAgents) }}</p>
                                            </div>
                                            <p class="title-desc1 mb-0 mt-1">Agentes Activos</p>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-6 pr-1 pr-md-1 mb-2">
                                        <div class="rounded-lg d-card-views5 text-left px-3 py-6">
                                            <div class="d-flex align-center">
                                                <v-icon size="25px" color="#b6b2b2" class="mr-2 iconos">mdi-robot-off</v-icon>
                                                <p class="mb-0 text-card" >{{ formatNumber(totalInactiveAgents) }}</p>
                                            </div>
                                            <p class="title-desc1 mb-0 mt-1">Agentes Inactivos</p>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-3 pr-1 pr-md-1 mb-2 mb-md-0">
                                        <div class="rounded-lg d-card-views1 text-left px-3 py-4">
                                            <div class="d-flex align-center">
                                                <v-icon size="25px" color="#7986CB" class="mr-2 iconos">mdi-message</v-icon>
                                                <p class="mb-0 text-card" >{{ formatNumber(totalChats) }}</p>
                                            </div>
                                            <p class="title-desc1 mb-0 mt-1">Mensajes</p>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-3 pl-1 px-md-1 mb-2 mb-md-0">
                                        <div class="rounded-lg d-card-views4 text-left px-3 py-4">
                                            <div class="d-flex align-center">
                                                <v-icon size="25px" color="#f9947b" class="mr-2 iconos">mdi-comment-account</v-icon>
                                                <p class="mb-0 text-card">{{ formatNumber(totalSessions) }}</p>
                                            </div>
                                            <p class="title-desc1 mb-0 mt-1">Sesiones</p>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-3 pl-1 px-md-1 mb-2 mb-md-0 pl-xs-0 pr-xs-0 d-card-view">
                                        <div class="rounded-lg d-card-views3 text-left px-3 py-4">
                                            <div class="d-flex align-center">
                                                <v-icon size="25px" color="#80DEEA" class="mr-2 iconos">mdi-forum-plus</v-icon>
                                                <p class="mb-0 text-card">{{ formatNumber(totalPositiveChats) }}</p>
                                            </div>
                                            <p class="title-desc1 mb-0 mt-1">Res. Positivas</p>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-3 pl-1 pl-md-1">
                                        <div class="rounded-lg d-card-views2 text-left px-3 py-4">
                                            <div class="d-flex align-center">
                                                <v-icon size="25px" color="#F48FB1" class="mr-2 iconos">mdi-forum-remove</v-icon>
                                                <p class="mb-0 text-card">{{ formatNumber(totalNegativeChats) }}</p>
                                            </div>
                                            <p class="title-desc1 mb-0 mt-1">Res. Erroneas</p>
                                        </div>
                                    </div>
                                </v-row>
                            </div>

                        </v-row>
                    </v-card>
                </v-col>

                <!-- Gráfica de Vistas con Degradado -->
                <v-col class="col-md-6 col-12 px-0 pl-md-2 mt-5 mt-md-0">
                    <v-card cols="12" class="rounded-lg px-5 py-4" elevation="2">
                        <v-row justify="space-between" no-gutters>
                            <div class="mb-0">
                                <h3 class="text-left title-dashboard">Actividad de ({{ selectedYear == 'Todos' ? 'Todos los años' : selectedYear }})</h3>
                                <p class="text-left desc-dashboard mb-0">Grafica lineal de interacciones.</p>
                            </div>
                            <div class="col-4 col-md-3">
                                <v-select
                                v-model="selectedYear"
                                :items="yearsList"
                                label="Datos del año"
                                class="mb-0 mb-md-4 mb-lg-0"
                                dense
                                hide-details
                                outlined
                                ></v-select>
                            </div>
                        </v-row>
                        <apexchart type="line" height="212" :options="chartOptions" :series="chartSeries" />
                    </v-card>
                </v-col>

                <v-col class="col-md-8 col-12 px-0 mt-5">
                    <v-card cols="12" class="rounded-lg px-5 py-4" elevation="2">
                        <div class="d-flex">
                            <h3 class="text-left title-dashboard">Usuarios y visitantes ({{ selectedYear == 'Todos' ? 'Todos los años' : selectedYear }})</h3>
                            <v-progress-circular
                                v-if="loadingAllStatistics"
                                indeterminate
                                color="#8061c2"
                                width="2"
                                size="20"
                                class="mt-2 ml-2"
                                ></v-progress-circular>
                        </div>
                        <p class="text-left desc-dashboard mb-8">
                            Graficos por mes de usuarios y visitantes.
                        </p>
                        <apexchart type="bar" height="300" :options="groupedChartOptions"
                            :series="groupedChartSeries" />
                    </v-card>
                </v-col>

                <v-col class="col-md-4 col-12 px-0 mt-md-2 mt-0 pt-0">
                    <v-col class="col-12 px-0 pl-md-4 mt-0">
                        <v-card cols="12" class="rounded-lg px-5 pt-4 pb-10" elevation="2">
                            <h3 class="text-left title-dashboard ">Alertas</h3>
                            <p class="text-left desc-dashboard mb-10">
                                Sesiones con respuestas erróneas.
                            </p>

                            <v-col cols="12" class="pa-0 mt-15">
                                <v-responsive class="scroll-data">
                                    <v-data-table :headers="headersAlerts" :items="alertsData"
                                        :loading="loadingCountry" >

                                        <template v-slot:item.user="{ item }">
                                            <div class="item-container">
                                                <span>{{ item.user }}</span>
                                            </div>
                                        </template>


                                        <template v-slot:item.messages="{ item }">
                                            <span>{{ formatNumber(item.messages) }}</span>
                                        </template>



                                        <template v-slot:item.check="{ item }">
                                            <v-checkbox
                                                v-model="item.check"
                                                color="#8061c2"
                                                @change="handleCheckAlert(item)"
                                            ></v-checkbox>
                                        </template>

                                        <template v-slot:item.options="{ item }">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon color="#8061c2" v-bind="attrs" v-on="on" @click="goToSession(item)">
                                                        <v-icon>mdi-eye</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Revisar sesión</span>
                                            </v-tooltip>
                                        </template>


                                    </v-data-table>
                                </v-responsive>
                            </v-col>
                        </v-card>
                    </v-col>
                </v-col>
            </v-row>
        </v-col>
    </v-col>
</template>

<script>
import axios from '@/axios.js';
import VueApexCharts from 'vue-apexcharts';

export default {
    components: {
        apexchart: VueApexCharts
    },
    data() {
        return {
            totalActiveAgents: 0,
            totalInactiveAgents: 0,
            totalChats: 0,
            totalSessions: 0,
            totalPositiveChats: 0,
            totalNegativeChats: 0,
            activeTab: 0,
            tabs: ['Países', 'Regiones', 'Ciudades'], // Las pestañas
            selectedYear: new Date().getFullYear(),
            yearsList: [],
            perPage: -1,
            page: 1,
            loadingCountry: false,
            loadingStatistics: false,
            loadingAllStatistics: false,
            dialog: false,
            headersAlerts: [
                {text: 'Usuario', value: 'user'},
                { text: 'Mensajes', value: 'messages' },
                { text: 'Resuelto', value: 'check' },
                { text: 'Opciones', value: 'options' },
            ],
            alertsData: [],
            chartOptions: {
                chart: {
                    id: 'views-chart',
                    toolbar: { show: false },
                    animations: { enabled: true }
                },
                xaxis: {
                    categories: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                },
                stroke: {
                    curve: 'smooth',
                    width: 4
                },
                colors: ['#7986cb', '#f9947b', '#80deea', '#f48fb1'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: 'horizontal',
                        shadeIntensity: 0.5,
                        gradientToColors: ['#40D756', '#8061C2'],
                        stops: [0, 100]
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                }
            },
            chartSeries: [
                {
                    name: 'Vistas Totales',
                    data: []  // Datos para vistas totales
                },
                {
                    name: 'Vistas Únicas',
                    data: []  // Datos para vistas únicas
                }
            ],
            // Opciones de la gráfica de barras agrupadas
            groupedChartOptions: {
                chart: {
                    type: 'bar',
                    stacked: false,
                    toolbar: { show: false },
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded',
                        dataLabels: {
                            position: 'top',
                        },
                    },
                },
                colors: ['#bbc3fc', '#ededed'],
                xaxis: {
                    categories: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                    labels: {
                        style: {
                            colors: '#000',
                            fontSize: '12px'
                        }
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                },
                fill: {
                    opacity: 1,
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'center',
                    markers: {
                        width: 12,
                        height: 12,
                        radius: 6,
                    }
                },
                dataLabels: {
                    enabled: false
                }
            },
            groupedChartSeries: [
                {
                    name: 'Harmonys',
                    data: [],
                },
            ]
        };
    },

    watch: {
        selectedYear() {
            this.fetchStatistics();
            this.fetchTotalStatistics();
            this.fetchAlerts();
        }
    },
    created() {
        this.generateYearsList();
        this.fetchStatistics();
        this.fetchTotalStatistics();
        this.fetchAlerts();
    },
    methods: {

        resetData (){
            this.alertsData = [];
            this.groupedChartSeries = [];
            this.groupedChartSeries2 = [];
            this.chartSeries = [];
            this.totalActiveAgents = 0;
            this.totalInactiveAgents = 0;
            this.totalChats = 0;
            this.totalSessions = 0;
            this.totalPositiveChats = 0;
            this.totalNegativeChats = 0;
        },

        generateYearsList() {
            const currentYear = new Date().getFullYear();
            const startYear = 2025;
            this.yearsList = [];
            this.yearsList.push('Todos');
            for (let year = currentYear; year >= startYear; year--) {
                this.yearsList.push(year);
            }
        },

        formatNumber(value) {
            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(value);
        },

        async fetchTotalStatistics() {
            this.loadingAllStatistics = true;
            try {
                const response = await axios.get(`/admin/get-agents-statistics-total?year=${this.selectedYear}`);
                const data = response.data;

                this.groupedChartSeries = [
                    {
                        name: 'Usuarios',
                        data: data.users_per_month || [],
                    },
                    {
                        name: 'Visitantes',
                        data: data.visitors_per_month || [],
                    }
                ];

                this.loadingAllStatistics = false;

            } catch (error) {
                this.loadingAllStatistics = false;
                console.error('Error fetching total statistics:', error);
            }
        },

        async fetchStatistics() {
            this.resetData();
            this.loadingStatistics = true;
            try {
                const response = await axios.get(`/admin/get-agents-statistics?year=${this.selectedYear}`);
                const data = response.data;

                this.totalActiveAgents = data.total_active_agents || 0;
                this.totalInactiveAgents = data.total_inactive_agents || 0;
                this.totalChats = data.total_chats || 0;
                this.totalSessions = data.total_sessions || 0;
                this.totalPositiveChats = data.total_positive_chats || 0;
                this.totalNegativeChats = data.total_negative_chats || 0;

                // Actualizar datos de la gráfica
                this.chartSeries = [
                    {
                        name: 'Chats',
                        data: data.chats_per_month || []
                    },
                    {
                        name: 'Sesiones',
                        data: data.sessions_per_month || []
                    },
                    {
                        name: 'Res. Positivas',
                        data: data.positive_chats_per_month || []
                    },
                    {
                        name: 'Res. Erroneas',
                        data: data.negative_chats_per_month || []
                    }
                ];

                this.loadingStatistics = false;
            } catch (error) {
                this.loadingStatistics = false;
                console.error('Error fetching statistics:', error);
            }
        },

        goToSession(item) {
            const url = this.$router.resolve({ name: 'AgentsChats', params: { id: item.id } }).href;
            window.open(url, '_blank');
        },

        async fetchAlerts(){
            try {
                this.loadingCountry = true;
                const response = await axios.get(`/admin/get-agent-alerts`, {
                    params: {
                        page: this.page,
                        per_page: this.perPage
                    }
                });

                this.alertsData = response.data.alerts.data.map(item => ({
                    id: item.id, // Agregamos el id
                    user: item.user.name,
                    messages: item.total_messages,
                    check: item.check
                }));

                this.loadingCountry = false;
            } catch (error) {
                console.error('Error fetching alerts:', error);
            } finally {
                this.loadingCountry = false;
            }
        },

        async handleCheckAlert(item) {
            try {
                const response = await axios.post('/admin/check-agent-alert', {
                    id: item.id
                });

                if (response.data.success) {
                    this.$vs.notify({
                        title: 'Resuelto',
                        text: response.data.message,
                        color: 'success',
                        icon: 'check_box',
                        position: 'bottom-center',
                        time: 5000,
                    });
                    // Recargar la lista de alertas
                    await this.fetchAlerts();
                }
            } catch (error) {
                console.error('Error checking alert:', error);
            }
        }
    }
};
</script>

<style scoped>

.flags {
    width: 21px !important;
}

.chip-container {
    display: flex;
    flex-wrap: wrap;  /* Permite que se dividan en múltiples filas */
    max-height: 100px; /* Ajusta esta altura si es necesario */
    overflow-x: auto;  /* Scroll horizontal */
    background-color: #f4e8ff;
    border-radius: 12px;
}

.title-desc {
    font-size: 15px;
    color: #676f7b;
}

.title-desc1 {
    font-size: 14px;
    color: #676f7b;
}

 ::v-deep .v-chip__content{
    font-weight: 800;
    color: #8e84c0;
    font-size: 10px;
    height: 18px !important;
}
::v-deep .v-chip {
    height: 15px !important;
}

.custom-tab {
    text-transform: none;
    font-size: 12px;
    font-weight: 500;
    padding: 8px 16px;
}

.scroll-data {
    height: 260px;
    overflow-y: auto;
}
.round-tab {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}
.title-card {
    color: #616181;
    font-weight: 400;
    font-size: 26px;
}

.text-card{
    font-size: 18px;
    color: #616181;
    font-weight: 400;
}
.d-card {
    background-color: #fff4de;
}

.d-card2 {
    background-color: #dcfce7;
}

.d-card3 {
    background-color: #f4e8ff;
}

.d-card-views1 {
    background-color: #e6e9ff;
}

.d-card-views2 {
    background-color: #ffebf8;
}

.d-card-views3 {
    background-color: #dcf8fc;
}

.d-card-views4 {
    background-color: #fff4de;
}

.d-card-views5 {
    background-color: #f0f0f0;
}

.d-card-views6 {
    background-color: #dcfce7;
}

.title-dashboard {
    color: #8061c2;
    font-weight: 500;
    margin-left: 10px;
    margin-top: 8px;
}

.desc-dashboard {
    color: gray;
    font-size: 14px;
    margin-left: 10px;
}

.title {
    font-size: 22px !important;
    color: #8061c2;
}

.desc {
    color: #737373;
    font-size: 15px;
}
.icon-maps {
    position: absolute;
    top: 10px;
    right: 10px;
}

@media (min-width: 1400px) and (max-width: 1600px){
    .text-card{
        font-size: 16px;
        margin-left: 5px;
    }
    .title-desc1{
        font-size: 12px;
        color: #616181;

    }
    .iconos{
        width: 10px;
        height: 10px;
    }
}

@media (min-width: 1060px) and (max-width: 1400px){
    .text-card{
        font-size: 14px;
    }
    .title-desc1{
        font-size: 13px;
    }
    .iconos{
        width: 20px;
        height: 20px;
    }
    .d-flex.align-center {
        flex-direction: column;
        text-align: left;
        align-items: flex-start !important;
        justify-content: flex-start !important;
        width: 100%;
    }

    .d-flex.align-center .mr-2 {
        margin-right: 0 !important;
        align-self: flex-start !important;
        margin-bottom: 4px;
    }
    :deep(.apexcharts-datalabels text) {
        font-size: 11px !important;
        font-weight: bold !important;
    }
}
@media (min-width: 1142px) and (max-width: 1185px) {
    :deep(.apexcharts-datalabels text) {
        font-size: 11px !important;
        font-weight: bold !important;
    }

}
@media (min-width: 1060px ) and (max-width: 1142px){
    .text-card{
        font-size: 12px;
    }
    .title-desc1{
        font-size: 13px;
    }
    .iconos{
        width: 15px;
        height: 15px;
    }
    .d-flex.align-center {
        flex-direction: column;
        text-align: left;
        align-items: flex-start !important;
        justify-content: flex-start !important;
        width: 100%;
    }

    .d-flex.align-center .mr-2 {
        margin-right: 0 !important;
        align-self: flex-start !important;
        margin-bottom: 4px;
    }
    :deep(.apexcharts-datalabels text) {
        font-size: 10px !important;
        font-weight: bold !important;
    }
}

@media (min-width: 960px) and (max-width: 1060px){
    .text-card{
        font-size: 10.8px;
    }
    .title-desc1{
        font-size: 12px;
    }
    .iconos{
        margin-top: 5px;
        width: 15px;
        height: 15px;
    }
    .d-flex.align-center {
        flex-direction: column;
        text-align: left;
        align-items: flex-start !important;
        justify-content: flex-start !important;
        width: 100%;
    }

    .d-flex.align-center .mr-2 {
        margin-right: 0 !important;
        align-self: flex-start !important;
        margin-bottom: 4px;
    }
    :deep(.apexcharts-datalabels text) {
        font-size: 9px !important;
        font-weight: bold !important;
    }

}

@media (min-width: 750px) and (max-width: 959px) {
    .d-card-view {
        padding-left: 0 !important;
        padding-right: 3px !important;
    }
    .d-card-views3{
        padding-left: 0 !important;
    }
    :deep(.apexcharts-datalabels text){
        font-size: 11px !important;
    }
}

@media (min-width: 561px) and (max-width: 750px) {
    :deep(.apexcharts-datalabels text) {
        font-size: 8.5px !important;
        font-weight: bold !important;
    }

}

@media (min-width: 522px) and (max-width: 561px) {
    :deep(.apexcharts-datalabels text) {
        font-size: 7px !important;
        font-weight: bold !important;
    }
}

@media (min-width: 430px) and (max-width: 522px) {
    :deep(.apexcharts-datalabels text) {
        font-size: 6px !important;
        font-weight: bold !important;
    }
}
@media (min-width: 300px) and (max-width: 430px) {
    :deep(.apexcharts-datalabels text) {
        font-size: 5px !important;
        font-weight: bold !important;
    }
}
:deep(.apexcharts-datalabels text) {
  font-weight: bold !important;
  white-space: nowrap !important;
}

</style>